<template>
  <ul class="navbar-nav me-auto mt-3">
    <h3 v-if="currentAgency">{{currentAgency.agency_name}}</h3>
  </ul>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AgencyBanner",
  computed: mapGetters("agency", ["currentAgency"])
};
</script>

<style scoped>
ul {
  float:left;
  text-align: left;
}
</style>
